import {
  Button,
  Colors,
  Modal,
  Typography
} from '@giantleap/components-library'
import * as React from 'react'
import styles from './style.module.scss'
import { IProps } from './types'

function EvaluationWarningModal({ onButtonClick, active, setActive }: IProps) {
  return (
    <Modal active={active} setActive={setActive} baseClassName={styles.wrap}>
      <Typography type="title" size="big" textAlign="center">
        Whoops<i style={{ color: Colors.purpleAccent }}>...</i>
      </Typography>
      <Typography type="text" textAlign="center">
        You’re currently <b>viewing a closed evaluation</b> in History mode
      </Typography>
      <Typography type="text" textAlign="center">
        Games and questionnaires are only accessible on the{' '}
        <b>currently active evaluation</b>
      </Typography>
      <Button color="purple" onClick={onButtonClick}>
        Resume Current Evaluation
      </Button>
    </Modal>
  )
}

export default EvaluationWarningModal



// WEBPACK FOOTER //
// ./src/components/EvaluationWarningModal/index.tsx